/**
 * Selectors
 *
 * It's like "views" in relational databases.
 * Store the most efficient format in the reducer state.
 * But to retrieve into easy to consume form, use selector.
 */
import { RootState } from "src/ipm-shared/store/model/reducers";
import ReducerFactory from "src/ipm-shared/Utils/ReduxReducer";
import paymentrequests from "./reducers";
import _get from "lodash-es/get";
import { PAYMENT_METHOD_TYPES } from "./const";
ReducerFactory.registerReducer({ paymentrequests });

export const getFees = (state: RootState) => ({
  amountOff: state.paymentrequests.amountOff,
  couponUsed: state.paymentrequests.couponUsed,
  exchangeRate: state.paymentrequests.exchangeRate,
  licenseFee: state.paymentrequests.licenseFee,
  paymentAmount: state.paymentrequests.paymentAmount,
  rateBeforeCoupon: state.paymentrequests.rateBeforeCoupon / 100,
  rateUsed: state.paymentrequests.rateUsed / 100,
  savings: state.paymentrequests.savings,
  total: state.paymentrequests.total,
  payeeQuoteToken: state.paymentrequests.payeeQuoteToken,
  flashPayFee: state.paymentrequests.flashPayFee,
  instantPayFee: state.paymentrequests.instantPayFee,
  isDeductedRate: state.paymentrequests.isDeductedRate,
  gstFee: state.paymentrequests.gstFee,
  bankPayoutFee: state.paymentrequests.bankPayoutFee,
  minimumTransactionFee: state.paymentrequests.minimumTransactionFee
});

export const getCurrentPaymentRequest = (state: RootState) => ({
  ...state.paymentrequests,
  payees: state.paymentrequests.payees.map(payee => ({
    ...payee,
    bankName: _get(state.banks.byId, `${payee.bankId}.name`, "")
  })),
  subtotal: state.paymentrequests.subtotal
});

export const getCurrentPurpose = (state: RootState) =>
  state.paymentrequests.currentPurpose;

export const getCurrentPaidCard = (state: RootState) =>
  state.paymentrequests.paidCard;

export const getCouponUsed = (state: RootState) =>
  state.paymentrequests.couponUsed;

export const getPaymentCountryCode = (state: RootState) =>
  state.paymentrequests.paymentCountryCode;

export const getPaymentCurrencyCode = (state: RootState) =>
  state.paymentrequests.paymentCurrencyCode;

export const getPaymentRequestPayees = (state: RootState) => ({
  ...state.paymentrequests.payees,
  purposeId: state.paymentrequests.purposeId
});

export const getPaymentMethodType = (state: RootState) =>
  state.paymentrequests.paymentMethodType;

export const isCryptoPaymentMethod = (state: RootState) =>
  state.paymentrequests.paymentMethodType === PAYMENT_METHOD_TYPES.CRYPTO;

export const getPaymentMethodId = (state: RootState) =>
  state.paymentrequests.paymentMethodId;

export const isCardPaymentMethod = (state: RootState) =>
  state.paymentrequests.paymentMethodType === PAYMENT_METHOD_TYPES.CARD;
